import { ActionColor } from '@doveit/bricks/dist/typings/components/action/types';
import { GoalMetric, PerformanceMetric, TimeRange } from '../../../../providers/api/dtos';

export enum PerformanceActionType {
  EDIT_TARGET = 'EDIT_TARGET',
}

export function getPerformanceAction(metric: GoalMetric, metrics: Record<GoalMetric, Record<TimeRange, PerformanceMetric>>) {
  const isAllAboveExpectations = Object.values(metrics).every((metricData) => metricData.yearly.status === 'ABOVE_EXPECTATIONS');
  const isSalesMetricAboveExpectations = metrics.sales.yearly.status === 'ABOVE_EXPECTATIONS';
  const isMetricAboveExpectations = metrics[metric].yearly.status === 'ABOVE_EXPECTATIONS';

  if (isAllAboveExpectations || (isSalesMetricAboveExpectations && isMetricAboveExpectations)) {
    return ({
      label: 'Imposta nuovo obiettivo',
      type: PerformanceActionType.EDIT_TARGET,
      color: 'success' as ActionColor,
    });
  }

  return undefined;
}
